import { useGetUserProfile } from './use-get-user-profile.hook';

export const usePreferredFirstName = () => {
  const { data, isLoading, error } = useGetUserProfile();

  // For the dropdown, we want to use the preferred first name if it exists, but if it doesn't,
  // we fall back to the first name.
  const preferredFirstName =
    data?.userProfile?.preferredFirstName ?? data?.userProfile?.firstName ?? '';

  return {
    data: { preferredFirstName },
    isLoading,
    error,
  };
};
